import React from "react";

const Footer = () => {
  return (
    <div>
      <div className="bg-[#F2F2F2] rounded-t-[50px] pt-20 pb-20">
        <div className="flex flex-col justify-between px-20 lg:px-40">
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 md:gap-6 lg:gap-10">
            <div className="flex flex-col gap-5">
              <img src="/idiablack.svg" width={80} alt="idea" />
              <p className="my-0">
                <label className="font-bold">Idia Corporation Pty Ltd</label>
                <br />
                Suite 112, Waterman Caribbean Park,
                <br /> 44 Lakeview Drive , Scoresby,
                <br /> Victoria 3179, Australia
              </p>
              <a
                className="no-underline text-[#282828]"
                href="hello@idiacorp.com"
              >
                hello@idiacorp.com
              </a>
              <a href="www.idiacorp.com">www.idiacorp.com</a>
            </div>

            <div className="my-0 w-full">
              <p className="mt-0 mb-1">Products</p>
              <div className="w-1/5 border border-[#282828] opacity-6"></div>
              <p className="text-[#3A56E8]">JobNinja</p>
              <p className="text-[#3A56E8]">Saleswin</p>
              <p className="text-[#3A56E8]">Neztdo</p>
              <p>Cach</p>
              <p>Nearit</p>
            </div>

            <div>
              <p className="my-0">Privacy Policy </p>
              <p>Terms & Conditions</p>
              <div className="flex flex-row gap-5">
                <img src="/x.svg" width={15} alt="x" />
                <img src="/linkdin.svg" width={20} alt="linkdin" />
                <img src="/insta.svg" width={20} alt="insta" />
                <img src="/fb.svg" width={10} alt="facebook" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
